module.exports = "/assets/dist/images/bodystyles_convertibles_sm.png?3440f50226f857e45ac5421e4ad1782d";